import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { InvoicingPermissions } from './permissions'

function guarded(
  perm: string | readonly string[],
  Page: ComponentType,
  mode: 'all' | 'any' = 'any',
): ComponentType {
  return createPermissionGuardedPage(perm, Page, { mode, administratorBypass: true })
}

export const invoicingRoutes: RouteObject[] = [
  {
    path: 'invoicing',
    lazy: async () => {
      const mod = await importWithChunkReload(() => import('./pages/invoicing-workspace-page'))
      const Page = mod.default ?? mod.InvoicingWorkspacePage
      return {
        Component: guarded(InvoicingPermissions.workspaceAccess, Page, 'any'),
      }
    },
  },
]
